import React from "react";
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import GIEButton from '../GIEButton/GieButton';
import GIEHeaderMobile from './GIEHeaderMobile';
import logo from "../../assets/logo-gie.svg";
import './Header.css';

class GIEHeader extends React.Component<any, any> {
  constructor(props) {
    super(props);
    this.state = {
      anchorEl: null
    }
  }

  goService = () => {
    window.location.href = "https://gie-sa.fr"
  }

  goMySpace = () => {
    window.location.href = "https://votre-espace.gie-sa.fr/admin/login"
  }

  render() {
    return (
      <div>
        <div className="d-none d-lg-block">
          <div className="header-wrapper">
            <img alt="https://gie-sa.fr" src={logo} height="50" width="156"/>

            <div className="header-links">
              <a href="https://gie-sa.fr/notre-entreprise" className="fw-bold text-decoration-none">
                Notre entreprise
              </a>
              <a href="https://gie-sa.fr/chauffage" className="fw-bold text-decoration-none">
                Chauffage
              </a>
              <a href="https://gie-sa.fr/climatisation" className="fw-bold text-decoration-none">
                Climatisation
              </a>
              <a href="https://gie-sa.fr/energies-renouvelables" className="fw-bold text-decoration-none">
                Énergies renouvelables
              </a>
              <a href="https://gie-sa.fr/offres-demploi" className="fw-bold text-decoration-none">
                Nous rejoindre
              </a>
              <a href="https://gie-sa.fr/faq" className="fw-bold text-decoration-none">
                FAQ
              </a>
            </div>

            <div className="d-flex justify-content-end gap-2">
              <GIEButton onClick={this.goService} classes={{root: 'blue-btn big-btn'}}>
                <span>Services en ligne</span>
                <ExpandMoreIcon className="expand-more-icon"/>
              </GIEButton>
              <GIEButton onClick={this.goMySpace} classes={{root: 'orange-btn big-btn'}}>Mon espace</GIEButton>
            </div>
          </div>
        </div>
        <div className="d-lg-none">
          <GIEHeaderMobile/>
        </div>
      </div>
    );
  }
}

export default GIEHeader;
